module.exports = __webpack_public_path__ + "static/media/logonew.43e61f1a.svg";